import React, { useCallback, useEffect, useState } from 'react'
import useApi from '../../hooks/useApi'
import { ListOsc } from '../Osc/ListOsc'
import { ActionsLog } from './ActionsLog'

export const ListForApprve = () => {
    
    const api = useApi()

    const [page, setPage] = useState<number>(1)
    const [newOsc,setNewosc] = useState<boolean>(false)

    const hasNewOsc = useCallback(async ()=>{
        await api.get<boolean>('admin/osc/check-new').then(res => {
            setNewosc(res.data);
        }).catch(console.log)
    },[api])

    useEffect(()=>{
        hasNewOsc();
    },[hasNewOsc])
    return (
        <div>
            <div className='grid grid-cols-5 my-5'>
                <div className={`font-semibold cursor-pointer border-b-2 
                ${page === 1 && "border-b-4 border-gray-800"}`}
                    onClick={() => setPage(1)}>
                    Últimas atividades
                </div>
                <div className={`font-semibold flex justify-center cursor-pointer border-b-2 ${page === 2 && "border-b-4 border-gray-800"}`} onClick={() => setPage(2)}>
                    Cadastros pendentes 
                    {newOsc && <div className='w-2 h-2 ml-1 bg-red-600 rounded-full'></div>}
                </div>
                <div className={`border-b col-span-3`}></div>
            </div>
            {page === 1 && <ActionsLog />}
            {page === 2 && <ListOsc noApproved/>}
        </div>
    )
}